"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestError = exports.NotFoundError = exports.InternalError = exports.AuthError = exports.CustomError = exports.ErrorMessages = void 0;
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["NotAUUID"] = "INVALID_ID";
    ErrorMessages["CantChangeId"] = "CANT_CHANGE_ID";
    ErrorMessages["MissingParameters"] = "MISSING_PARAMETERS";
    ErrorMessages["NotFoundInDatabase"] = "NOT_FOUND_IN_DATABASE";
    ErrorMessages["DatabaseError"] = "DATABASE_ERROR";
    ErrorMessages["ServerError"] = "SERVER_ERROR";
    ErrorMessages["UnknownCountry"] = "UNKNOWN_COUNTRY";
    ErrorMessages["UnknownRegion"] = "UNKNOWN_REGION";
    ErrorMessages["ForbiddenOperation"] = "FORBIDDEN_OPERATION";
    ErrorMessages["UserDisconnected"] = "USER_DISCONNECTED";
    ErrorMessages["InvalidUserName"] = "USERNAME_INVALID";
    ErrorMessages["InvalidPassword"] = "PASSWORD_INVALID";
    ErrorMessages["WrongPassword"] = "PASSWORD_INCORRECT";
    ErrorMessages["UserAlreadyRegistered"] = "USER_ALREADY_REGISTERED";
    ErrorMessages["InvalidEmail"] = "EMAIL_INVALID";
    ErrorMessages["AuthentificationFailed"] = "AUTH_FAILED";
    ErrorMessages["EmailAlreadyInUse"] = "EMAIL_ALREADY_USED";
    ErrorMessages["MissingPassword"] = "PASSWORD_MISSING";
    ErrorMessages["InvalidField"] = "INVALID_FIELD";
    ErrorMessages["ConnectedFromAnotherDevice"] = "CONNECTED_FROM_ANOTHER_DEVICE";
    ErrorMessages["InvalidHappiness"] = "HAPPINESS_NOT_VALID";
    ErrorMessages["InvalidLastName"] = "LASTNAME_INVALID";
    ErrorMessages["InvalidFirstName"] = "FIRSTNAME_INVALID";
    ErrorMessages["UserNotFound"] = "USER_NOT_FOUND";
    ErrorMessages["ChestNotFound"] = "CHEST_NOT_FOUND";
    ErrorMessages["ChestAlreadyOpen"] = "CHEST_ALREADY_OPEN";
    ErrorMessages["NotEnoughResources"] = "NOT_ENOUGH_RESOURCES";
    ErrorMessages["CantCollectResourceType"] = "CANT_COLLECT_RESOURCE_TYPE";
    ErrorMessages["NoMineOfResourceType"] = "NO_MINE_OF_RESOURCE_TYPE";
    ErrorMessages["StandLevelNotFound"] = "STAND_LEVEL_NOT_FOUND";
    ErrorMessages["VanLevelTooLow"] = "VAN_LEVEL_TOO_LOW";
    ErrorMessages["InvalidToken"] = "INVALID_TOKEN";
    ErrorMessages["DeviceNotFound"] = "DEVICE_NOT_FOUND";
    ErrorMessages["CouldNotVerifyAppleUser"] = "COULD_NOT_VERIFY_APPLE_USER";
    ErrorMessages["BattleNotFound"] = "BATTLE_NOT_FOUND";
    ErrorMessages["WrongNotificationName"] = "WRONG_NOTIFICATION_NAME";
    ErrorMessages["WrongMessageType"] = "WRONG_MESSAGE_TYPE";
    ErrorMessages["MissingNotificationTitle"] = "MISSING_NOTIFICATION_TITLE";
    ErrorMessages["NotificationNotFound"] = "NOTIFICATION_NOT_FOUND";
    ErrorMessages["FoursquareError"] = "FOURSQUARE_ERROR";
    ErrorMessages["FoursquareJsonParsingError"] = "FOURSQUARE_JSON_PARSING";
    ErrorMessages["NoMapAssociatedWithPlace"] = "NO_MAP_ASSOCIATED_WITH_PLACE";
    ErrorMessages["CantAttackOwnPlace"] = "CANT_ATTACK_OWN_PLACE";
    ErrorMessages["PlaceAlreadyInBattle"] = "PLACE_ALREADY_IN_BATTLE";
    ErrorMessages["PlaceNotFound"] = "PLACE_NOT_FOUND";
    ErrorMessages["NotPlaceOwner"] = "NOT_PLACE_OWNER";
    ErrorMessages["AlreadyUpgrading"] = "ALREADY_UPGRADING";
    ErrorMessages["PlaceWithoutOwner"] = "PLACE_WITHOUT_OWNER";
    ErrorMessages["PlaceNotUpgrading"] = "PLACE_NOT_UPGRADING";
    ErrorMessages["PlaceTypeNotFound"] = "PLACETYPE_NOT_FOUND";
    ErrorMessages["PlaceTypeLevelNotFound"] = "PLACE_TYPE_LEVEL_NOT_FOUND";
    ErrorMessages["PlaceUpgradeWithoutCost"] = "PLACE_UPGRADE_WITHOUT_COST";
    ErrorMessages["PlaceRepairWithoutCost"] = "PLACE_REPAIR_WITHOUT_COST";
    ErrorMessages["PlaceTooFar"] = "PLACE_TOO_FAR";
    ErrorMessages["CantUpgradeOtherOwnerPlace"] = "CANT_UPGRADE_OTHER_OWNER_PLACE";
    ErrorMessages["LevelNotFound"] = "LEVEL_NOT_FOUND";
    ErrorMessages["UnknownInvitePolicy"] = "UNKNOWN_INVITE_POLICY";
    ErrorMessages["AlreadyInAlliance"] = "ALREADY_IN_ALLIANCE";
    ErrorMessages["InvitationAlreadyPending"] = "ALREADY_PENDING";
    ErrorMessages["UserNotInAlliance"] = "USER_NOT_IN_ALLIANCE";
    ErrorMessages["AllianceLeaderCantLeave"] = "LEADER_CANNOT_LEAVE";
    ErrorMessages["NoPendingInvitation"] = "NO_PENDING_INVITATION";
    ErrorMessages["AllianceNotFound"] = "ALLIANCE_NOT_FOUND";
    ErrorMessages["NoPendingApplication"] = "NO_PENDING_APPLICATION";
    ErrorMessages["SessionNotFound"] = "SESSION_NOT_FOUND";
    ErrorMessages["UnregisteredTask"] = "UNREGISTERED_TASK";
    ErrorMessages["FailedToRemoveJob"] = "FAILED_TO_REMOVE_JOB";
    ErrorMessages["ItemNotFound"] = "ITEM_NOT_FOUND";
    ErrorMessages["ItemNotInChest"] = "ITEM_NOT_IN_CHEST";
    ErrorMessages["ItemTemplateNotFound"] = "ITEM_TEMPLATE_NOT_FOUND";
    ErrorMessages["UserNotOwnerOfItem"] = "ITEM_DOES_NOT_BELONG_TO_USER";
    ErrorMessages["ResourceNotInChest"] = "RESOURCE_NOT_IN_CHEST";
    ErrorMessages["CharacterNotFound"] = "CHARACTER_NOT_FOUND";
    ErrorMessages["UserNotOwnerOfCharacter"] = "CHARACTER_DOES_NOT_BELONG_TO_USER";
    ErrorMessages["CharacterLevelTooLow"] = "CHARACTER_LEVEL_IS_TOO_LOW_FOR_ITEM_RARITY";
    ErrorMessages["CharacterReachedMaxLevel"] = "CHARACTER_REACHED_MAX_LEVEL";
    ErrorMessages["DormitoryLevelTooLow"] = "DORMITORY_LEVEL_TOO_LOW";
    ErrorMessages["NotEnoughCharactersToKick"] = "NOT_ENOUGH_CHARACTERS";
    ErrorMessages["MapNotFound"] = "MAP_NOT_FOUND";
    ErrorMessages["GoalNotFound"] = "GOAL_NOT_FOUND";
    ErrorMessages["IncompatibleGoal"] = "GOAL_IMCOMPATIBLE";
    ErrorMessages["BanditNotFound"] = "BANDIT_NOT_FOUND";
    ErrorMessages["UserNotABandit"] = "USER_NOT_BANDIT";
    ErrorMessages["AlreadyFriends"] = "ALREADY_FRIENDS";
    ErrorMessages["NoInvitationToRefuse"] = "NO_INVITATION_TO_REFUSE";
    ErrorMessages["NoInvitationToAccept"] = "NO_INVITATION_TO_ACCEPT";
    ErrorMessages["NotFriends"] = "NOT_FRIENDS";
    ErrorMessages["FriendshipsDoNotMatch"] = "FRIENDSHIPS_DO_NOT_MATCH";
    ErrorMessages["AlreadyInvited"] = "ALREADY_INVITED";
    ErrorMessages["GiftCooldown"] = "GIFT_COOLDOWN";
    ErrorMessages["NotInvited"] = "NOT_INVITED";
    ErrorMessages["CantBefriendSelf"] = "CANT_BEFRIEND_SELF";
})(ErrorMessages = exports.ErrorMessages || (exports.ErrorMessages = {}));
class CustomError extends Error {
    constructor(message) {
        super();
        this.$type = "LoneStoneStudio.CityInvaders.ErrorDTO, CityInvaders.Runtime";
        this.message = message;
        this.name = this.constructor.name;
    }
}
exports.CustomError = CustomError;
class AuthError extends CustomError {
}
exports.AuthError = AuthError;
class InternalError extends CustomError {
}
exports.InternalError = InternalError;
class NotFoundError extends CustomError {
}
exports.NotFoundError = NotFoundError;
class RequestError extends CustomError {
}
exports.RequestError = RequestError;
//# sourceMappingURL=errors.js.map